module.exports = __webpack_public_path__ + "img/zoom-03.8ba359ed.webp";